module.exports = __webpack_public_path__ + "img/1.5e0f6496.png";